import React from 'react'
import Form from 'react-bootstrap/Form'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Select from 'react-select';
import { reactSelectStyles } from '../../../../utils/constants';
import CustomAccordion from '../../../CustomAccordion/CustomAccordion';

import "./SurgicalDressing.scss"

const slingBraceAplicationOptions = [
  {value: "None used", label: "None used"},
  {value: "Sling", label: "Sling"},
  {value: "Immobilization-abducted sling", label: "Immobilization-abducted sling"},
  {value: "Immobilization-neutral wedge", label: "Immobilization-neutral wedge"},
]

const SurgicalDressing = ({
  formData,
  form,
  arrayIndex,
  onChangeHandler,
  onRemoveHandler,
  showToggleButtons = false,
  filterType = 'include',
  onFilterTypeChange = () => {},
  activeKey,
  onAccordionChange = () => {},
  closeFromBottom = false
}) => {
  const handleAccordionToggle = () => {
    onAccordionChange(form);
  };
  switch(form) {
    case "slingBraceApplication": {
      return (
        <CustomAccordion
          title="Sling/Brace Application"
          previewData={formData}
          showToggleButtons={showToggleButtons}
          filterType={filterType}
          onFilterTypeChange={onFilterTypeChange}
          onRemove={() => onRemoveHandler(arrayIndex)}
          category="surgical-dressing"
          isOpen={activeKey === form}
          onToggle={handleAccordionToggle}
          closeFromBottom={closeFromBottom}
        >
          <Form>
            <Row>
              <Col>
                <Form.Label>Sling/Brace Application</Form.Label>
                <Select
                  isMulti
                  value={slingBraceAplicationOptions.filter(option => formData.slingBrace.split(",").includes(option.value))}
                  name="slingBrace"
                  options={slingBraceAplicationOptions}
                  className="basic-multi-select"
                  classNamePrefix="select"
                  menuPortalTarget={document.body}
                  styles={reactSelectStyles}
                  onChange={(selectedValues) => {onChangeHandler(arrayIndex, "slingBrace", selectedValues.map(selectedValue => selectedValue.value).join(","))}}
                />
              </Col>
            </Row>
          </Form>
        </CustomAccordion>
      )
    }
    default: {
      return null
    }
  }
}

export default SurgicalDressing